import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { DataSeries } from '@next/core-lib/models';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import {
  GetObservationsResponse,
  GetWeeklyKpiDataRequest,
  ObservationsRegistration,
  Parameter,
  WeeklyKpiDataResponse,
} from '../models/performance.model';

@Injectable({
  providedIn: 'root',
})
export class PoultryNextRearingService {
  private baseUrl = `${this.env.API_BASE_URL}/service/poultrynext-rearing`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  upsertObservations(
    observations: ObservationsRegistration[],
    cycleId: number,
    barnId: number,
    sectionId: number,
  ): Observable<object> {
    return this.http.post(
      `${this.baseUrl}/secure/observation/cycle/${cycleId}/barn/${barnId}/section/${sectionId}`,
      { observations },
      {},
    );
  }

  getObservations(cycleId: number): Observable<ObservationsRegistration[]> {
    return this.http
      .get<GetObservationsResponse>(`${this.baseUrl}/secure/observation/${cycleId}`)
      .pipe(
        map((response: GetObservationsResponse) => response.observations),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<ObservationsRegistration[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  getWeeklyKpiData(
    cycleId: number,
    request: GetWeeklyKpiDataRequest,
  ): Observable<WeeklyKpiDataResponse> {
    return this.http.post<WeeklyKpiDataResponse>(
      `${this.baseUrl}/secure/cycle/${cycleId}/performance/weekresults`,
      request,
      {},
    );
  }

  getDailyKpiTimeseries(
    cycleId: number,
    parameter: Parameter,
    sectionIds: number[],
  ): Observable<DataSeries<number, number>> {
    return this.http.get<DataSeries<number, number>>(
      `${
        this.baseUrl
      }/secure/cycle/${cycleId}/performance/kpi/${parameter.toString()}/timeseries/sections/${sectionIds.join(
        ',',
      )}`,
      {},
    );
  }
}
